<template>
  <div class="product-system-layout">
    <div class="layout-root">
      <div class="animate__animated animate__backInDown big">
        <img class="big-bg" src="@images/bg/ps_big1.gif" alt="" />
        <div class="big-src-root">
          <img class="big-src" :src="bigSrc" :alt="currentProduct.name || ''" />
        </div>
      </div>

      <div class="animate__animated animate__backInRight describe-root">
        <div class="carousel-layout">
          <div class="cir"></div>
          <div class="cir2"></div>
          <div class="cir3"></div>
          <div class="line"></div>
          <img class="arrow" src="@images/icon/ps_arrow_left.png" alt="" @click="onClickArrow(0)" />
          <div ref="CAROUSEL" class="carousel-images">
            <div
              v-for="(item, index) in PRODUCT_LIST"
              :key="item.id || index"
              :class="{ 'image-item': true, 'image-item-bg': position === index }"
              :style="{ transform: `translate(${translateX}vw, 0)` }"
              @click="onImageClick(index)"
            >
              <img class="image" :src="item.localUrl" :alt="item.name" />
            </div>
          </div>
          <img class="arrow" src="@images/icon/ps_arrow_right.png" alt="" @click="onClickArrow(1)" />
        </div>

        <div class="text-content-layout">
          <span class="title">{{ currentProduct.name }}</span>
          <p :class="language == 'en-US' ? 'content-en' : 'content'" style="white-space: pre-line">
            {{ currentProduct.content }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from '@/request/api/model'

export default {
  data() {
    return {
      position: 0,
      translateX: 0,
      carousel_width: 0,
      language: localStorage.getItem('Language'),
      productListCN: [],
      productListEN: []
    }
  },
  computed: {
    PRODUCT_LIST() {
      return this.language === 'zh-CN' ? this.productListCN : this.productListEN
    },
    currentProduct() {
      return this.PRODUCT_LIST[this.position] || {}
    },
    bigSrc() {
      return this.currentProduct.localUrl || ''
    }
  },
  created() {
    if (this.language === 'zh-CN') {
      this.getCNData()
    } else {
      this.getENData()
    }
  },
  methods: {
    async getCNData() {
      this.productListCN = await this.getSlideshowData('0,1')
    },
    async getENData() {
      this.productListEN = await this.getSlideshowData('0,2')
    },
    async getSlideshowData(contentType) {
      try {
        const res = await getData({
          categoryId: '1985184716741496833',
          contentType,
          publishChannel: '0,1'
        })

        if (!res || res.code !== 0 || !Array.isArray(res.data)) {
          return []
        }

        return res.data.reduce((list, item) => {
          const fileList = Array.isArray(item.contentFileList) ? item.contentFileList : []
          const localUrl = fileList.find((url) => typeof url === 'string' && url.trim())

          if (localUrl) {
            list.push({
              id: item.id,
              name: item.contentTitle,
              content: item.contentDescription,
              localUrl
            })
          }
          return list
        }, [])
      } catch (error) {
        console.error(error)
        return []
      }
    },
    init() {
      // this.carousel_width = +window.getComputedStyle(this.$refs.CAROUSEL).width.replace('px', '')
    },
    onClickArrow(index) {
      const baseX = 9 // vw
      // const count = PRODUCT_LIST.length > 3 ? PRODUCT_LIST.length - 3 : PRODUCT_LIST.length
      const count = this.PRODUCT_LIST.length
      const totalWidth = baseX * count
      const canTransWidth = totalWidth - 27 // 选择器carousel-images width 27.5vw
      if (index === 0) {
        if (this.position > 0) {
          this.position -= 1
        }
        if (totalWidth - (this.position + 1) * baseX >= 27 && this.translateX < 0) {
          this.translateX += baseX
        }
        // if (this.position > this.translateX !== 0) {
        //   this.translateX += baseX
        // }
      } else if (index === 1) {
        if (this.position < count - 1) {
          this.position += 1
        }
        if ((this.position + 1) * baseX >= 27 && Math.abs(this.translateX) < canTransWidth) {
          this.translateX -= baseX
        }
      }
    },
    onImageClick(index) {
      this.position = index
    }
  }
}
</script>

<style lang="scss" scoped>
.product-system-layout {
  background-color: white;
  display: flex;
  height: 100%;
  align-items: center;
  overflow: hidden;

  .layout-root {
    height: 80%;
    width: 100%;
    display: flex;
    align-items: center;
    // overflow: hidden;
    margin: 20px;
    padding-bottom: 5vh;
    // background: rgb(187, 181, 181);

    .big {
      height: 80%;
      position: relative;
      margin-left: 5vw;
      margin-right: 2vw;
      display: flex;
      flex: 0.9;
      align-items: center;
      justify-content: center;
      // background: rgb(187, 181, 181);
      .big-bg {
        width: 32vw;
      }

      .big-src-root {
        position: absolute;
        width: 23vw;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        .big-src {
          position: absolute;
          width: 100%;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }

    .describe-root {
      flex: 1.2;
      height: 29vw;
      // margin-top: -5vw;
      width: 0;

      .carousel-layout {
        display: flex;
        position: relative;
        top: 0%;
        left: -2vw;
        align-items: center;

        .cir {
          position: absolute;
          background: #a71b20;
          border-radius: 50%;
          width: 0.5vw;
          height: 0.5vw;
          margin-left: -14.1vw;
          top: 0;
          bottom: 0;
          margin-top: auto;
          margin-bottom: auto;
        }
        .cir2 {
          position: absolute;
          // border: 2px solid #a71b20c2;
          border-color: #a71b20;
          border-style: solid;
          border-width: 2px;
          border-radius: 50%;
          width: 1vw;
          height: 1vw;
          margin-left: -14.1vw - 0.25vw;
          top: 0;
          bottom: 0;
          margin-top: auto;
          margin-bottom: auto;
        }
        .cir3 {
          position: absolute;
          // border: 2px solid #a71b20c2;
          border-color: #a71b20;
          border-style: solid;
          border-width: 2px;
          border-radius: 50%;
          width: 1.4vw;
          height: 1.4vw;
          margin-left: -14.1vw - 0.45vw;
          top: 0;
          bottom: 0;
          margin-top: auto;
          margin-bottom: auto;
        }

        .line {
          position: absolute;
          width: calc(100% + 13.9vw + 2vw + 2vw);
          height: 1px;
          border-top: 2px solid #a71b20;
          margin-left: -13.9vw;
          // right: 0%;
          // top: 8.4%;
        }

        .carousel-images {
          display: flex;
          // width: 52%;
          width: 27vw;
          overflow: hidden;
          height: 9vw;
        }

        .arrow {
          width: 4vw;
          height: 4vw;
          margin: 1vw;
          z-index: 2;
        }

        .image-item-bg {
          background: url('~@images/bg/ps_small.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        .image-item {
          // display: flex;
          // justify-content: center;
          // align-items: center;
          display: block;

          .image {
            display: block;
            width: 9vw;
            height: 9vw;
            padding: 1.1vw;
          }
        }
      }
      .text-content-layout {
        overflow: hidden;
        position: relative;
        top: 9%;
        color: #333;

        .title {
          font-size: 2.3vw;
          font-weight: bold;
          font-family: MicrosoftYaHei-Bold;
        }

        .content {
          margin-top: 2.8vh;
          font-size: 1.5vw;
          color: #666;
          padding-right: 50px;
        }
        .content-en {
          font-size: 1.3vw;
          line-height: 1.5;
          margin-top: 1vh;
          color: #666;
        }
      }
    }
  }
}
</style>
